"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FButton = void 0;
const react_1 = __importDefault(require("react"));
const FButton = ({ title, outlined, rounded, variant = "primary", className = "", onClick = () => { }, prefix, postfix, style, type = "button", disabled = false, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: `f-btn f-btn-${variant} f-btn-${type} ${rounded && "f-btn-rounded"} ${outlined && "f-btn-outlined"} ${className} ${postfix ? "f-pl--7" : ""} ${prefix ? "f-pr--7" : ""}`, onClick: onClick, style: style ? Object.assign({}, style) : undefined, type: type, disabled: disabled },
            prefix && react_1.default.createElement("span", { className: "f-btn-icon f-prefix" }, prefix),
            react_1.default.createElement("span", { className: "f-btn-title" }, title),
            postfix && react_1.default.createElement("span", { className: "f-btn-icon f-postfix" }, postfix))));
};
exports.FButton = FButton;
//# sourceMappingURL=Fbutton.js.map